// Intent handler registrar. Each domain module exports a register() that
// returns its disposers; this conductor calls them in order and returns one
// composite disposer. Wired from @app/bootstrap via registerAppIntents().

import * as camera from './camera';
import * as colormap from './colormap';
import * as slices from './slices';
import * as volume from './volume';
import * as contour from './contour';
import * as fieldlines from './fieldlines';
import * as selection from './selection';
import * as selections from './selections';
import * as reductions from './reductions';
import * as grid from './grid';
import * as theme from './theme';
import * as dataset from './dataset';
import * as scene from './scene';
import * as screenshot from './screenshot';
import * as timestep from './timestep';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function registerAppIntents(store: Store<State>, viewer: ViewerContext): () => void {
    const offs: Array<() => void> = [
        ...camera.register(store, viewer),
        ...colormap.register(store, viewer),
        ...slices.register(store, viewer),
        ...volume.register(store, viewer),
        ...contour.register(store, viewer),
        ...fieldlines.register(store, viewer),
        ...selection.register(store, viewer),
        ...selections.register(store, viewer),
        ...reductions.register(store, viewer),
        ...grid.register(store, viewer),
        ...theme.register(store, viewer),
        ...dataset.register(store, viewer),
        ...scene.register(store, viewer),
        ...screenshot.register(store, viewer),
        ...timestep.register(store, viewer),
    ];
    return () => offs.forEach((off) => off());
}
